import { environment as defaultEnvironment } from '../../../../src/environments/environment.defaults';

export const environment = {
  ...defaultEnvironment,
  production: true,
  hmr: false,
  getTokenUrl: '/sitecoreapi/spa/digest',
  verzekeringskiezerUrl: '/ApiProxy/OLSVerzekeringskiezerAnonymous/OphalenVerzekeringsKiezerSchadecoach',
  keepAliveUrl: '/sitecoreapi/spa/keepalive',
  applicationInsightsKeyUrl: '/sitecoreapi/foundation/logging/appinsightkey',
  tekstenUrl: '/sitecoreapi/shareddata/webapi/SharedData/getshareddataitems?list=OLS_Data/Teksten'
};
